<template>
  <div>
    <div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">
      交易管理>订单管理>订单详情
    </div>
    <div class="newADcontent">
      <div class="adContent">
        <div class="title" style="margin-top: 20px;">
          <div class="blue"></div>
          <div style="flex: 1;">订单信息</div>
        </div>
        <el-form ref="form" label-position="left">
          <el-form-item>
            <div class="list">
              <div>
                <span>订单编号</span>
                <span>{{ order.orderNo }}</span>
              </div>
              <div>
                <span>订单类型</span>
                <span>{{ order.orderType|typeFormat }}</span>
              </div>
              <div>
                <span>下单时间</span>
                <span>{{ order.addTime == null ? '/' : order.addTime }}</span>
              </div>
              <div>
                <span>订单状态</span>
                <el-select v-model="editData.status" placeholder="请选择" style="width: 100px;" size="small">
                  <el-option v-for="item in orderStateList" :key="item.value" :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div>
                <span>服务门店</span>
                <span>{{ order.storeName }}</span>
              </div>
              <div>
                <span>发型师</span>
                <span>{{ order.workerName }}</span>
              </div>
              <div>
                <span>排队编号</span>
                <span>{{ order.rankNo }}</span>
              </div>
              <div style="display: flex">
                <span>备注信息</span>
                <span>
                  <el-input v-model="editData.remark" type="textarea"
                            style="width: 180px;"></el-input>
                </span>
              </div>
              <div style="flex: 1;">
                <el-image :src="editData.orderPicture" :preview-src-list=[editData.orderPicture]
                          style="width:100px;height: 80px;"></el-image>
                <span>截图是否合格</span>
                <el-radio-group v-model="editData.isValid">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </div>
            </div>
          </el-form-item>
          <div class="title" style="margin-top: 20px;">
            <div class="blue"></div>
            <div style="flex: 1;">用户信息</div>
          </div>
          <el-form-item>
            <div class="list">
              <div>
                <span>用户昵称</span>
                <span>{{ order.nickName }}</span>
              </div>
              <div>
                <span>联系电话</span>
                <span>{{ order.telphone }}</span>
              </div>
              <div>
                <span>用户类型</span>
                <span>{{ order.userType }}</span>
              </div>
            </div>
          </el-form-item>
          <div class="title" style="margin-top: 20px;">
            <div class="blue"></div>
            <div style="flex: 1;">服务/商品</div>
          </div>
          <div style="font-size: 14px">
            <div v-for="item in order.service">{{item.name}} ￥{{item.price}}</div>
          </div>
          <div class="title" style="margin-top: 20px;">
            <div class="blue"></div>
            <div style="flex: 1;">支付信息</div>
          </div>
          <el-form-item>
            <div class="list">
              <div>
                <span>支付总额</span>
                <span>
                  <el-input v-model="editData.payTotal" type="text"
                            style="width: 150px;" size="small"></el-input>
                </span>
              </div>
              <div>
                <span>支付方式</span>
                <span>{{ order.payType }}</span>
              </div>
              <div>
                <span>付款时间</span>
                <span>{{ order.payTime == null ? '/' : order.payTime }}</span>
              </div>
              <div>
                <span>参与活动</span>
                <span>{{ order.inActivity }}</span>
              </div>
              <div>
                <span>优惠减免</span>
                <span>{{ order.couponTotal }}</span>
                <span>{{ this.couponTitle }}</span>
              </div>
              <div>
                <span>卡金闲时优惠</span>
                <span>{{ order.useCardLeisureMoney }}</span>
              </div>
              <div>
                <span>卡金抵扣</span>
                <span>{{ order.useCardScore }}</span>
              </div>
              <div>
                <span>优惠券抵扣</span>
                <span>{{ order.couponTotal || 0}}</span>
              </div>
              <div>
                <span>美团商品</span>
                <span>{{ order.youzanDealTitle }}</span>
              </div>
              <div>
                <span>美团券码</span>
                <span>{{ order.youzanCode }}</span>
              </div>
              <div>
                <span>美团抵扣</span>
                <span>{{ order.youzanTotal }}</span>
              </div>
              <div>
                <span>美团补贴金额（商户分摊）</span>
                <span>{{ order.youzanMerchantAmount }}</span>
              </div>
            </div>
          </el-form-item>

          <el-form-item style="text-align:center;margin: 50px;">
            <router-link to="/assetManagement">
              <el-button @click="reload()">取 消</el-button>
            </router-link>
            <el-button type="primary" style="margin-left:20px;" @click="edit()">确 定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      couponTitle: "",
      order: {},
      tableData: [],
      orderStateList: [{
        label: "排队中",
        value: 0,
      }, {
        label: "服务中",
        value: 1,
      }, {
        label: "待付款",
        value: 2,
      }, {
        label: "已支付",
        value: 3,
      }, {
        label: "已取消",
        value: -1,
      }, {
        label: "部分退款",
        value: -2,
      }, {
        label: "售后订单",
        value: -3,
      }, {
        label: "已完成",
        value: 5,
      }, {
        label: "已发货",
        value: 6,
      }, {
        label: "代发货",
        value: 7,
      }, {
        label: "支付中",
        value: 21
      }, {
        label: "预约中",
        value: 30,
      }],
      orderTypeList: [{
        label: "全部",
        value: "",
      }, {
        label: "普通订单",
        value: "1",
      }, {
        label: "买赠订单",
        value: "2",
      }, {
        label: "次卡订单",
        value: "3",
      }, {
        label: "优惠券订单",
        value: "4",
      }, {
        label: "兑换码订单",
        value: "5",
      }, {
        label: "会员订单",
        value: "6",
      }, {
        label: "会员续费订单",
        value: "7",
      }, {
        label: "推广员订单",
        value: "8",
      }, {
        label: "美团订单",
        value: "9",
      }, {
        label: "染发次卡订单",
        value: "10",
      }, {
        label: "预约订单",
        value: "20",
      }],
      editData: {}
    };
  },
  filters: {
    typeFormat(val) {
      switch (val) {
        case "1":
          return "普通订单";
        case "2":
          return "企业剪订单";
        case "3":
          return "春季次卡订单";
        // case "4": return "优惠券订单";
        case "5":
          return "膨胀券订单";
        case "6":
          return "会员订单";
        case "7":
          return "会员续费订单";
        case "8":
          return "推广员订单";
        case "9":
          return "美团订单";
        case "10":
          return "染发订单";
        case "11":
          return "权益订单";
        case "14":
          return "卡金充值";
        case "20":
          return "预约订单";
        default:
          return "/";
      }
    },
  },
  methods: {
    reload() {
      this.editData = JSON.parse(JSON.stringify(this.order));
    },
    getOrder() {
      this.$http.get("dOrder/details?id=" + this.id).then(res => {
        this.order = res.body.data;
        this.editData = JSON.parse(JSON.stringify(this.order));
      });
    },
    edit() {
      let isOk = true;
      if ((this.order.status != this.editData.status) || (this.order.remark != this.editData.remark) || (this
        .order.payTotal != this.editData.payTotal) || (this.order.isValid != this.editData.isValid)) {
        this.$http.post("dOrder/edit", {
          id: this.id,
          status: this.editData.status,
          remark: this.editData.remark,
          isValid: this.editData.isValid,
          payTotal: this.editData.payTotal
        }).then(res => {
          if (res.body.code === 200) {
            this.$message.success('修改成功');
          } else {
            this.$message.error(res.body.msg);
            isOk = false
          }
        })
      }
      if (this.order.score != this.editData.score || this.order.proposal != this.editData.proposal) {
        let str = "?orderId=" + this.id + "&commentScore=" + this.order.score + "&proposal=" + this.order
          .proposal
        if (this.order.score && this.order.proposal) {
          this.$http.get("dOrder/commentEdit" + str).then(res => {
            if (res.body.code) {
              this.$message('修改评价成功');
            }
          })
        }
      }

      if (isOk) {
        this.$router.push({
          path: '/assetManagement'
        });
      }
    }
  },
  computed: {
    statusFomcat() {
      return (val) => {
        var result;
        this.orderStateList.forEach(ele => {
          if (ele.value == val) result = ele.label;
        });
        return result;
      }
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.couponTitle = this.$route.query.couponTitle;
    this.getOrder();
  },
};
</script>

<style lang="less" scoped>
p {
  margin: 0;
  padding: 0;
}

.list {
  display: flex;
  flex-wrap: wrap;

  div {
    width: 25%;

    span {
      margin-right: 15px;
    }
  }
}

.list2 {
  width: 100%;
  display: flex;

  > div {
    flex: 1;

    &:nth-child(1) {
      margin-right: 25px;
    }
  }
}

.title {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3e3e3e;
  display: flex;
  font-weight: bold;
  margin-bottom: 10px;

  .blue {
    width: 5px;
    height: 15px;
    background: #409eff;
    border-radius: 2px;
    margin-right: 8px;
    position: relative;
    top: 4px;
  }
}

.newADcontent {
  display: flex;

  // & > div{
  // 	display: inline-block;
  // }
  .adContent {
    flex: 2;
  }

  .adExamples {
    flex: 1;
    padding: 0 30px;

    img {
      width: 300px;
      height: auto;
    }
  }
}

/deep/ .tabelContent .el-checkbox__label {
  display: none;
}
</style>
